/*
 * Layering in the app shells. The z-index SCALE lives in CSS, once —
 * `--wb-z-*` in app/assets/tailwind/app_theme.css — and components name a
 * step of it (`z-[var(--wb-z-chat)]`) instead of a number. These are the
 * class strings for the steps components use, so a typo cannot quietly drop
 * a layer to `auto`, and the rules that go with being above a modal.
 */

/** Live support: launcher, panel and floating call bar. Above dialogs and the guided walkthrough. */
export const Z_CHAT = 'z-[var(--wb-z-chat,10010)]'
/** A modal's scrim and window (Radix Dialog). */
export const Z_DIALOG = 'z-[var(--wb-z-dialog,50)]'
/** The veil behind a modal: dark in both themes (light mode swaps `--color-black` to white). */
export const SCRIM = 'bg-[var(--wb-scrim,rgb(0_0_0/0.62))]'

/**
 * Marks a surface that floats ABOVE whatever modal the page has open — the
 * live support chat. A modal must not treat a press there as "outside", and
 * CSS gives it its pointer back while Radix has set `pointer-events: none` on
 * <body> (see SupportChatStyles).
 */
export const ABOVE_MODALS_ATTR = 'data-wb-above-modals'

/** Whether a press or focus landed on a surface that floats above modals (the chat, the walkthrough). */
export function isAboveModals(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest(`[${ABOVE_MODALS_ATTR}], .wb-tour`))
}

/**
 * Whether a modal (or any Radix layer that disables outside pointer events)
 * is open: Radix's DismissableLayer marks it on <body> itself.
 */
export function pageModalOpen(): boolean {
  return typeof document !== 'undefined' && document.body.style.pointerEvents === 'none'
}
